export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-500italic-18d00f739ff1e1c52db1a1c0d9e98129.woff";